import { Button } from '@sleepstation/components'
import {
  SmallFormFailureMessage,
  SmallFormSuccessMessage,
} from '@sleepstation/components-form'
import { STATUS } from '@sleepstation/const'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { useMutation } from 'urql'
import { FeedbackContentConsentMutation } from '../../../../../graphql/documents'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ContactMe = ({ content, enrolmentId, statement }) => {
  const [status, setStatus] = useState(STATUS.DEFAULT)

  const [consentToFeedbackResult, consentToFeedback] = useMutation(
    FeedbackContentConsentMutation
  )

  const { data, error } = consentToFeedbackResult

  if (status === STATUS.PENDING) {
    if (data) {
      setStatus(STATUS.SUCCEEDED)
    } else if (error) {
      setStatus(STATUS.FAILED)
    }
  }

  const {
    button: { label },
    messages: { success, failure },
  } = content

  const isPending = status === STATUS.PENDING

  if (!status || isPending) {
    return (
      <ThemeProvider theme={defaultAltTheme}>
        <Button
          kind="secondary"
          data-cy="contact-me-consent-button"
          onClick={() => {
            setStatus(STATUS.PENDING)
            consentToFeedback({
              enrolmentId,
              statement,
            })
          }}
          isSubmitting={isPending}
        >
          {label}
        </Button>
      </ThemeProvider>
    )
  }

  if (status === STATUS.SUCCEEDED) {
    return <SmallFormSuccessMessage {...success} />
  }

  return <SmallFormFailureMessage {...failure} />
}

ContactMe.propTypes = {
  content: PropTypes.object.isRequired,
  enrolmentId: PropTypes.string.isRequired,
  statement: PropTypes.string.isRequired,
}

export default ContactMe
